import { render, staticRenderFns } from "./contract-group-remove-modal.component.vue?vue&type=template&id=a0532b04&scoped=true&"
import script from "./contract-group-remove-modal.component.vue?vue&type=script&lang=ts&"
export * from "./contract-group-remove-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-group-remove-modal.component.vue?vue&type=style&index=0&id=a0532b04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0532b04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
